var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUsers = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 12c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4Zm1.5 1H8c-3.31 0-6 2.691-6 6v1h15v-1c0-3.309-2.691-6-6-6Z",
  fill: "#00BAC6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.604 11.048a5.67 5.67 0 0 0 .75-3.44c-.178-1.784-1.174-3.361-2.802-4.44l-1.105 1.666c1.119.742 1.8 1.799 1.918 2.974a3.693 3.693 0 0 1-1.072 2.986L13.1 11.986l1.618.475c4.232 1.24 4.28 5.496 4.28 5.539h2c0-1.789-.955-5.285-4.395-6.952Z",
  fill: "#00BAC6"
})));
export { SvgUsers as ReactComponent };
export default __webpack_public_path__ + "4e9612af77cfd356a214e78aa0ca3f15.svg";